export const ACCESS_APPROVALS_ITEMS_TAB_ID = "AccessApprovals-Items";